import { supabase } from '../lib/supabase';

export const siteReportService = {
  async getReportsBySite(siteId) {
    const { data, error } = await supabase?.from('site_reports')?.select('*, user_profiles(full_name)')?.eq('site_id', siteId)?.order('report_date', { ascending: false });
    return { data, error };
  },

  async getReportByDate(siteId, date) {
    const { data, error } = await supabase?.from('site_reports')?.select('*')?.eq('site_id', siteId)?.eq('report_date', date)?.maybeSingle();
    return { data, error };
  },

  async saveReport({ siteId, companyId, reportDate, reportText, generatedBy }) {
    const { data, error } = await supabase?.from('site_reports')?.upsert(
        {
          site_id: siteId,
          company_id: companyId,
          report_date: reportDate,
          report_text: reportText,
          generated_by: generatedBy,
          updated_at: new Date()?.toISOString(),
        },
        { onConflict: 'site_id,report_date' }
      )?.select()?.single();
    return { data, error };
  },

  async deleteReport(reportId) {
    const { error } = await supabase?.from('site_reports')?.delete()?.eq('id', reportId);
    return { error };
  },
};
